import I18n from 'I18n';
import { useState } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import fetchStatus, { fromJSON } from '../data/fetchStatus';
import fetchTwoFactorMethod from '../data/fetchTwoFactorMethod';
import { redirectTo2FASetup } from '../utils/redirectTo2FASetup';
export const useTwoFactorReAuth = () => {
  const [hasSecondaryMethod, setHasSecondaryMethod] = useState(false);
  const [obfuscatedInfo, setObfuscatedInfo] = useState('');
  const [authMethod, setCurrentAuthMethod] = useState();
  function initializeTwoFactorReAuth({
    onSuccess,
    openModal,
    skipVerificationIfNotSet
  }) {
    // No checkCookieIssuer call since passkey initialization already checks it
    fetchStatus().then(status => {
      const validatedStatus = fromJSON(status);
      if (validatedStatus && validatedStatus.get('secondary')) {
        setHasSecondaryMethod(!!validatedStatus.get('secondary'));
      }
      fetchTwoFactorMethod('PRIMARY').then(methodData => {
        if (methodData) {
          const validatedMethod = methodData.method;
          setObfuscatedInfo(methodData.obfuscatedInfo || '');
          setCurrentAuthMethod(validatedMethod);
        }
        openModal();
      }).catch(err => {
        if (skipVerificationIfNotSet) {
          onSuccess();
        } else if (err.status === 400) {
          redirectTo2FASetup(window.location);
        } else {
          FloatingAlertStore.addAlert({
            titleText: I18n.text('reAuth.error.FALLBACK.title'),
            message: I18n.text('reAuth.error.FALLBACK.descTwo'),
            type: 'danger'
          });
        }
      });
    }).catch(() => {
      FloatingAlertStore.addAlert({
        titleText: I18n.text('reAuth.error.FALLBACK.title'),
        message: I18n.text('reAuth.error.FALLBACK.descTwo'),
        type: 'danger'
      });
    });
  }
  return {
    hasSecondaryMethod,
    obfuscatedInfo,
    authMethod,
    initializeTwoFactorReAuth
  };
};